import { useClubLogo } from '../lib/useClubLogo';
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';

const SOCIAL = {
  instagram: 'https://www.instagram.com/dresden_devils/',
  facebook: 'https://www.facebook.com/EHVDresdenDevils/',
};



export default function Footer() {
  const LOGO_URL = useClubLogo();
  return (
    <footer className="bg-[hsl(0,0%,3%)] border-t border-white/5 py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] p-0.5 flex-shrink-0">
                <img src={LOGO_URL} alt="Logo" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
              </div>
              <div>
                <span className="font-bold text-white" style={{ fontFamily: 'Space Grotesk' }}>DRESDEN </span>
                <span className="font-bold text-[#CC0000]" style={{ fontFamily: 'Space Grotesk' }}>DEVILS</span>
              </div>
            </div>
            <p className="text-xs text-white/30 leading-relaxed">
              EHV Dresden Devils e.V.<br />
              Gegründet 17. März 1997<br />
              Leidenschaft auf dem Eis, Gemeinschaft im Verein!
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white mb-4" style={{ fontFamily: 'Space Grotesk' }}>Navigation</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-white/40 hover:text-white/70 transition-colors duration-200">Start</Link>
              <Link to="/kader" className="block text-sm text-white/40 hover:text-white/70 transition-colors duration-200">Kader</Link>
              <Link to="/admin" className="block text-sm text-white/40 hover:text-white/70 transition-colors duration-200">Admin</Link>
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white mb-4" style={{ fontFamily: 'Space Grotesk' }}>Kontakt</h3>
            <div className="space-y-2 text-sm text-white/40">
              <p>Norman Bradler</p>
              <p>Fetscherstraße 29, 01307 Dresden</p>
              <a href="mailto:Dresden.devils@gmail.com" className="text-[#46C7FF] hover:text-[#A9E7FF] transition-colors duration-200">
                Dresden.devils@gmail.com
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/20">&copy; {new Date().getFullYear()} EHV Dresden Devils e.V. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-4">
            <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/40 hover:text-white/70 hover:bg-white/10 transition-colors duration-200">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/40 hover:text-white/70 hover:bg-white/10 transition-colors duration-200">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="/impressum" className="text-xs text-white/20 hover:text-white/40 transition-colors duration-200">Impressum</a>
            <a href="/datenschutz" className="text-xs text-white/20 hover:text-white/40 transition-colors duration-200">Datenschutz</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
